import { render, staticRenderFns } from "./BrandmL.vue?vue&type=template&id=7762b85d&"
import script from "./BrandmL.vue?vue&type=script&lang=js&"
export * from "./BrandmL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports